<template>
  <v-card outlined height="168" class="d-flex flex-column pa-6">
    <template v-if="user">
      <div class="d-flex align-start flex-grow-1" style="gap: 16px">
        <v-avatar size="40" color="grey lighten-3">
          <v-img v-if="user.profilePicUrl" :src="user.profilePicUrl" />
          <v-icon v-else>mdi-account</v-icon>
        </v-avatar>

        <div class="flex-grow-1 overflow-hidden">
          <Typography as="p" variant="subtitle-1" class="text-left mb-1">{{
            user.tableDisplayName
          }}</Typography>
          <Typography as="p" variant="body-1" class="text-left mb-1">{{
            user.businessEmail || user.businessPhone
          }}</Typography>
          <Typography
            v-if="balanceText"
            as="p"
            variant="body-2"
            class="grey--text text--darken-1 text-left"
            >{{ balanceText }}</Typography
          >
        </div>

        <v-btn icon small @click="$emit('clear')">
          <v-icon size="20">mdi-close</v-icon>
        </v-btn>
      </div>
    </template>

    <template v-else>
      <div class="d-flex flex-column align-center justify-center flex-grow-1" style="gap: 16px">
        <Button outlined rounded @click="$emit('select')">Select {{ label }}</Button>
      </div>
    </template>

    <div class="d-flex justify-center">
      <Typography as="p" variant="subtitle-1">{{ label }}</Typography>
    </div>
  </v-card>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";
import Button from "@/components/generic/Button.vue";
import formatCurrency from "@/mixins/formatCurrency.js";

export default {
  name: "UserMergeCard",
  components: { Typography, Button },
  mixins: [formatCurrency],
  props: {
    label: {
      type: String,
      required: true,
    },
    user: {
      type: Object,
      default: null,
    },
    balance: {
      type: Object,
      default: null,
    },
  },
  emits: ["select", "clear"],
  computed: {
    balanceText() {
      if (!this.balance) return null;
      const parts = [this.formatCurrency(this.balance.cashBalance)];
      (this.balance.otherBalances || []).forEach((b) => {
        parts.push(this.formatCurrency(b.balance, b));
      });
      return parts.join(" • ");
    },
  },
};
</script>
